import React from "react";
import {
  Box,
  Typography,
  SxProps,
  Theme,
  TypographyProps,
} from "@mui/material";

interface FooterProps {
  sx?: SxProps<Theme>;
  textColor?: TypographyProps["color"];
}

const Footer: React.FC<FooterProps> = ({ sx, textColor = "textSecondary" }) => {
  return (
    <Box
      component="footer"
      sx={{
        textAlign: "center",
        padding: "20px",
        borderTop: "1px solid #e0e0e0",
        marginTop: "40px",
        ...sx,
      }}
    >
      <Typography variant="body2" color={textColor}>
        © {new Date().getFullYear()} Yukino. All Rights Reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
